import { combineReducers } from 'redux'
import { RECEIVE_USERS, RECEIVE_USER } from '../actions/user-actions.js'
import { RESET_STORE } from '../actions/currentUser-actions'

const userSearch = (state = { query: '', results: []}, action) => {
  switch(action.type) {
    case RECEIVE_USERS: return {...state, results: action.results, query: action.query}
    case RESET_STORE: return { query: '', results: []}
    default: return state
  }
}

const detail = (state = {}, action) => {
  switch(action.type) {
    case RECEIVE_USER: return action.user
    case RESET_STORE: return {}
    default: return state
  }
}

export default combineReducers( {
  userSearch,
  detail
})
